import { connect } from 'react-redux';
import { login, loginWith2FA } from '../../redux/actions/auth';
import Login from './components/Login';
import Login2 from './components/Login';

const mapStateToProps = (state) => ({
  authenticating: state.auth.authenticating,
  authenticated: state.auth.authenticated,
  token: state.auth.token,
  error: state.auth.error,
  status: state.auth.loginStatus,
  is2faEnabled: state.auth.is2faEnabled,
  user: state.user,
});

const mapDispatchToProps = {
  login,
  loginWith2FA,
};

export default Login;
